import styled from 'styled-components';

const Pagination = styled.ul`
	margin: 0px;
	padding: 0px;
	display: flex;
	list-style: none;
`;
export default Pagination;
